import React from 'react';
import styled from 'styled-components/macro';
import { Locale } from '../types';
import Interpretation from './Interpretation';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

const Button = styled.button`
  padding: 0.5rem 1rem;
  outline: none;
  border: none;
  background-color: rgb(31, 93, 234) !important;
  max-width: 10rem;
  margin: 1rem 0;
  color: white;
  border-radius: 5px;
  cursor: pointer;
`;

const emptyInterprettion = {
  title: {
    en: '',
    de: '',
    fr: '',
    it: '',
  },
  interpretationText: {
    en: '',
    de: '',
    fr: '',
    it: '',
  },
  recommendationText: {
    en: '',
    de: '',
    fr: '',
    it: '',
  },
  isRecommendation: true,
  icon: 'warn',
  visibleIfType: 'build',
  isActive: false,
};

interface Props {
  push: (interpretation: any) => void;
  remove: (index: number) => void;
  values: any;
  currentLang: Locale;
  name: string;
  questionsList: string[];
}

const Interpretations = ({
  push,
  remove,
  values,
  currentLang,
  name,
  questionsList,
}: Props) => {
  return (
    <Container>
      <Button onClick={() => push(emptyInterprettion)} type="button">
        Add interpretation
      </Button>
      <Content>
        {values.map(
          (
            { isRecommendation, visibleIfType, proportions, isActive }: any,
            index: number
          ) => {
            return (
              <Interpretation
                key={`${name}.${index}`}
                name={`${name}.${index}`}
                currentLang={currentLang}
                remove={() => remove(index)}
                isRecommendation={isRecommendation}
                visibleIfType={visibleIfType}
                questionsList={questionsList}
                proportions={proportions}
                isActive={isActive}
              />
            );
          }
        )}
      </Content>
    </Container>
  );
};

export default Interpretations;
